import { __assign } from "tslib";
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { OfficeWorkload } from '@office-start/officehome-types';
import { useUpdateUserStorage } from '@office-start/user-storage-service';
import { HarmonyThemeId, HarmonyThemeMode, } from '@office-start/visual-types';
import { useWebStorageSetUserItem } from '@office-start/web-storage-utility';
import { useMemo } from 'react';
import { HARMONY_THEME_USER_STORAGE_KEY } from './../model/harmonyThemeUserStorage';
/**
 * @param previousThemeData Previous theme data (may be undefined)
 * @param partialThemeData  Partial theme data
 * @returns Fully populated harmony theme data
 */
export var getHarmonyThemeData = function (previousThemeData, partialThemeData) {
    // Initialize if undefined
    var defaultHarmonyThemeData = {
        id: HarmonyThemeId.Office,
        lastModifiedTimeUtc: Date.now(),
        mode: HarmonyThemeMode.System,
        preferHarmonyTheme: false,
        version: 1,
    };
    return __assign(__assign(__assign({}, defaultHarmonyThemeData), previousThemeData), partialThemeData);
};
export var useSetHarmonyTheme = function () {
    var officeComponentContext = useOfficeComponentContext().data;
    var updateRemoteStorage = useUpdateUserStorage(HARMONY_THEME_USER_STORAGE_KEY, getHarmonyThemeData);
    var updateLocalStorage = useWebStorageSetUserItem(HARMONY_THEME_USER_STORAGE_KEY, getHarmonyThemeData);
    return useMemo(function () {
        if ((officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload) === OfficeWorkload.Hwa) {
            return updateLocalStorage;
        }
        return updateRemoteStorage;
    }, [
        officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload,
        updateLocalStorage,
        updateRemoteStorage,
    ]);
};
//# sourceMappingURL=useSetHarmonyTheme.js.map